<div class="alert alert-danger mt-4" role="alert" *ngIf="errorMessage !== ''">
  {{ errorMessage }}
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="(errorMessage === '') && (serverError === null)">

  <div class="floating-alert-container">
    <div class="alert alert-dismissible" role="alert"
         [class.alert-success]="modalResult.status === CallbackResultStatus.success"
         [class.alert-danger]="modalResult.status === CallbackResultStatus.error"
         *ngIf="modalResult">
      {{ modalResult.text }}
      <button type="button" class="close" (click)="modalResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-info alert-dismissible" role="alert"
         *ngIf="loadingTaxRates || loadingOrgConfig || savingOrgConfig">
      Loading...
    </div>
  </div>

  <h2>
    Tax Rates
  </h2>

  <p class="text-secondary">
    Rates set here can be used throughout Capitan.
  </p>

  <div class="row">
    <div class="col-xl-6 col-lg-8">

      <ng-container *ngIf="!this.loadingOrgConfig">

        <div class="mb-3">
          <label for="price_includes_tax">
            Tax List Price Policy
          </label>
          <select class="custom-select"
                  id="price_includes_tax"
                  name="price_includes_tax"
                  [disabled]="savingOrgConfig"
                  [class.disabled]="savingOrgConfig"
                  [(ngModel)]="this.orgConfig.price_includes_tax"
                  (ngModelChange)="this.saveOrgConfig()">
            <option [ngValue]="false">Price does not include tax</option>
            <option [ngValue]="true">Price includes tax</option>
          </select>
          <small class="form-text text-muted">
            This determines whether prices configured in the Staff Site and displayed in the Climber App are inclusive or exclusive of tax.
          </small>
        </div>

        <div class="mb-3">
          <label for="tax_display_format">
            Tax Display Format
          </label>
          <select class="custom-select"
                  id="tax_display_format"
                  name="tax_display_format"
                  [disabled]="savingOrgConfig"
                  [class.disabled]="savingOrgConfig"
                  [(ngModel)]="this.orgConfig.tax_display_format"
                  (ngModelChange)="this.saveOrgConfig()">
            <option [ngValue]="TaxDisplayFormat.tax">Generic ("Tax")</option>
            <option [ngValue]="TaxDisplayFormat.vat">VAT</option>
            <option [ngValue]="TaxDisplayFormat.gst">GST</option>
          </select>
          <small class="form-text text-muted">
            This determines what term is used to refer to tax amount in receipts.
          </small>
        </div>

      </ng-container>

      <ng-container *ngIf="this.loadingOrgConfig">

        <div class="mb-2">
          <label>
            Tax List Price Policy
          </label>
          <select class="custom-select disabled" disabled>
            <option>Loading...</option>
          </select>
          <small class="form-text text-muted">
            This determines whether prices configured in the Staff Site and displayed in the Climber App are inclusive or exclusive of tax.
          </small>
        </div>

        <div class="mb-2">
          <label>
            Tax Display Format
          </label>
          <select class="custom-select disabled" disabled>
            <option>Loading...</option>
          </select>
          <small class="form-text text-muted">
            This determines what term is used to refer to tax amount in receipts.
          </small>
        </div>

      </ng-container>

      <label>
        Tax Rates
      </label>

      <div class="rounded-table-wrapper">
        <table class="table">

          <thead>
            <tr>
              <th>Name</th>
              <th>Rate</th>
              <th></th>
            </tr>
          </thead>

          <tbody>

            <ng-container *ngIf="taxRateResultsPresent()">
              <tr *ngFor="let taxRate of taxRateList">
                <td>{{ taxRate.name }}</td>
                <td>{{ taxRate.rate_percent }}%</td>
                <td class="table-button-cell">
                  <button class="btn btn-outline-primary btn-sm float-right"
                          (click)="openEditTaxRateModal(taxRate)">
                    Edit
                  </button>
                  <button class="btn btn-outline-danger btn-sm float-right mr-2"
                          (click)="openRemoveTaxRateModal(taxRate)">
                    Remove
                  </button>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!taxRateResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingTaxRates ? 'Loading...' : 'No tax rates' }}
              </td>
            </tr>
            </ng-container>

            <tr *ngIf="!loadingTaxRates">
              <td colspan="99" class="table-button-cell">
                <button class="btn btn-outline-success btn-block"
                        (click)="openAddTaxRateModal()">
                  Click to add
                </button>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>
  </div>

</div>
